<template>
<div class="product-image-side">
  <img :src="image" :alt="imageAlt" :title="imageTitle" width="771" height="447">
</div>
<div class="product-content-side">
  <div class="prices-wrapper clearfix">
    <div v-if="isPayment1" class="price-row">
      <div class="price">{{ price_payment1 }} грн</div>
      <div class="price-text">{{ text.price_one_person_pay_before }} <span class="date-payment">{{ date_payment1 }}</span></div>
    </div>
    <div v-if="isPayment2" class="price-row">
      <div class="price">{{ price_payment2 }} грн</div>
      <div class="price-text">{{ text.price_one_person_pay_before }} <span class="date-payment">{{ date_payment2 }}</span></div>
    </div>
    <div v-if="isPayment3" class="price-row">
      <div class="price">{{ price_payment3 }} грн</div>
      <div class="price-text">{{ text.price_one_person_pay_before }} <span class="date-payment">{{ date_payment3 }}</span></div>
    </div>
    <div v-if="isPrepay && price" class="price-row">
      <div class="price">{{ price }} грн</div>
      <div class="price-text">{{ text.price_one_person }}</div>
    </div>
    <div v-if="isPrice1" class="price-row">
      <div class="price-label">{{ label_price1 }}</div>
      <div class="column-price">
        <label for="price1" :class="{ active: selectedPrice == 'price1' }">
          <input v-model="selectedPrice" type="radio" id="price1" name="price" value="price1" checked="checked" />
          <span v-if="isPrice1Action" class="price">{{ price1_action }} грн</span><span :class="{'price-old': isPrice1Action, 'price': !isPrice1Action}">{{ price1 }} грн</span>
        </label>
      </div>
      <div class="price-text">{{ text.price_one_person }}</div>
    </div>
    <div v-if="isPrice2" class="price-row">
      <div class="price-label">{{ label_price2 }}</div>
      <div class="column-price">
        <label for="price2" :class="{ active: selectedPrice == 'price2' }">
          <input v-model="selectedPrice" type="radio" id="price2" name="price" value="price2" checked="checked" />
          <span v-if="isPrice2Action" class="price">{{ price2_action }} грн</span><span :class="{'price-old': isPrice2Action, 'price': !isPrice2Action}">{{ price2 }} грн</span>
        </label>
      </div>
      <div class="price-text">{{ text.price_one_person }}</div>
    </div>
    <div v-if="isPrice3" class="price-row">
      <div class="price-label">{{ label_price3 }}</div>
      <div class="column-price">
        <label for="price3" :class="{ active: selectedPrice == 'price3' }">
          <input v-model="selectedPrice" type="radio" id="price3" name="price" value="price3" checked="checked" />
          <span v-if="isPrice3Action" class="price">{{ price3_action }} грн</span><span :class="{'price-old': isPrice3Action, 'price': !isPrice1Action}">{{ price3 }} грн</span>
        </label>
      </div>
      <div class="price-text">{{ text.price_one_person }}</div>
    </div>
    <div v-if="price_materials" class="price-row">
      <div class="price">{{ price_materials }} грн</div>
      <div class="price-text">{{ text.price_materials }}</div>
    </div>
    <div v-if="price_video" class="price-row">
      <div class="price">{{ price_video }} грн</div>
      <div class="price-text">{{ text.price_video }}</div>
    </div>
  </div>
  <div class="info-wrap">
    <div v-if="isPayment" class="date-begin"><i class="icon icon-calendar"></i>Старт {{ date }}</div>
    <div v-if="city.length" class="city"><i class="icon icon-pin"></i>{{ text.m }} {{ city }}</div>
  </div>
</div>
<div class="product-buttons clearfix">
  <div @click="addToBasket('full')" v-if="isPayment" id="button-buy" class="product-button button-buy">{{ text.register }}</div>
  <div @click="addToBasket('materials')" v-if="price_materials" id="button-buy-materials" class="product-button button-buy">{{ text.buy_materials }}</div>
  <div @click="addToBasket('video')" v-if="price_video" id="button-buy-video" class="product-button button-buy">{{ text.buy_video }}</div>
</div>
</template>
<script>

import { mapState } from 'vuex';
import { mapMutations } from 'vuex'
import qs from 'qs';
import axios from 'axios'

export default {
  data: () => {
    return {
      selectedPrice: ''
    }
  },

  computed: {
    ...mapState([
      'langcode',
      'text',
      'nid',
      'current_date',
      'date',
      'date_full',
      'image',
      'imageAlt',
      'imageTitle',
      'city',
      'price',
      'price_materials',
      'price_video',
      'date_payment1',
      'price_payment1',
      'date_payment2',
      'price_payment2',
      'date_payment3',
      'price_payment3',
      'price1',
      'price2',
      'price3',
      'price1_action',
      'price2_action',
      'price3_action',
      'label_price1',
      'label_price2',
      'label_price3',
      'basketItems'
    ]),

    isPayment1() {
      return this.date_payment1 && this.price_payment1 && this.date_payment1 > this.current_date
    },

    isPayment2() {
      return this.date_payment2 && this.price_payment2 && this.date_payment2 > this.current_date
    },

    isPayment3() {
      return this.date_payment3 && this.price_payment3 && this.date_payment3 > this.current_date
    },

    isPrepay() {
      return !this.isPayment1 && !this.isPayment2 && !this.isPayment3 && this.date_full > this.current_date
    },

    isPayment() {
      return ( this.price && this.date_full > this.current_date ) || this.isPrice1 || this.isPrice2 || this.isPrice3
    },

    isPrice1() {
      return this.price1 && this.date_full > this.current_date
    },

    isPrice2() {
      return this.price2 && this.date_full > this.current_date
    },

    isPrice3() {
      return this.price3 && this.date_full > this.current_date
    },

    isPrice1Action() {
      return ( this.price1_action > 0 && this.price1_action < this.price1 ) && this.date_full > this.current_date
    },

    isPrice2Action() {
      return ( this.price2_action > 0 && this.price2_action < this.price2 ) && this.date_full > this.current_date
    },

    isPrice3Action() {
      return ( this.price3_action > 0 && this.price3_action < this.price3 ) && this.date_full > this.current_date
    },

    defaultPrice() {
      if ( this.price1 ) {
        return 'price1'
      } else if ( this.price2 ) {
        return 'price2'
      } else if ( this.price3 ) {
        return 'price3'
      }
      return  ''
    },

  },

  mounted() {
    this.selectedPrice = this.defaultPrice
  },

  methods: {

    ...mapMutations([
      'updateBasketItems'
    ]),

    addToBasket(selectedPrice) {
      selectedPrice = this.selectedPrice ? this.selectedPrice : selectedPrice
      let data = {
        id: this.nid,
        selectedPrice: selectedPrice,
        langcode: 1,
        quantity: 1
      }
      axios.post('/basket/add',
      qs.stringify(data),
      {
        emulateJSON: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }
      ).then((response) => {
        window.dataLayer.push({'event': 'form-sent', 'form-action': 'AddToCartEducation'})
        this.updateBasketItems(response.data)
        window.location.href = "/basket";
      })

    },

  }

}

</script>
